// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"ebf85675","970":"cc96150b"}[chunkId] + ".chunk.css";
};